import { connect } from 'react-redux';
import Simulator from './Simulator';
import timeDepositActions from '../../../../../store/actions/timeDeposit.action';
import googleAnalytics from '../../../../../store/actions/googleAnalytics.action';

const mapStateToProps = state => ({
  amount: state.simulation.amount,
  depositType: state.simulation.depositType,
  step: state.simulation.step,
  timeLimit: state.simulation.timeLimit,
  expirationDate: state.simulation.expirationDate,
  defaultExpirationDate: state.simulation.defaultExpirationDate,
  disabledDays: state.simulation.disabledDays,
  montoLimitDap: state.simulation.montoLimitDap
});

const mapDispatchToProps = dispatch => {
  return {
    changeAmount: amount => dispatch(timeDepositActions.changeAmount(amount)),
    changeTimeLimit: timeLimit =>
      dispatch(timeDepositActions.changeTimeLimit(timeLimit)),
    changeDepositType: depositType =>
      dispatch(timeDepositActions.changeDepositType(depositType)),
    getSimulation: params => dispatch(timeDepositActions.getSimulation(params)),
    changeExpirationDate: (date, inhabiles) =>
      dispatch(timeDepositActions.changeExpirationDate(date, inhabiles)),
    getHolidays: (params, timeLimit) => 
      dispatch(timeDepositActions.getHolidaysDays(params, timeLimit)),
    setDefaultExpDate: (defExpDate) => 
      dispatch(timeDepositActions.setDefaultExpDate(defExpDate)),
    googleAnalytics: (params) => {
        googleAnalytics.registerGoogleAnalytics(params);
    },
    getConfiguracionDap: ()=> dispatch(timeDepositActions.getConfiguracionDap())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Simulator);
